module.exports = __webpack_public_path__ + "1.5.0-unryo/img/deploy.086273fc.jpg";